export enum PaymentTemplateStyle {
    BulletPoints= "BulletPoints",
    Paragraph ="Paragraph",
    ItemizedTable ="ItemizedTable"
}